<template>
  <div>
    <el-skeleton v-if="skeleton" animated />
    <div v-else-if="hasNotifications">
      <div v-for="notification in notifications" :key="notification.id" class="mb--md">
        <dara-notification-card :data="notification" />
      </div>
      <dara-pagination
        v-if="showPagination"
        :page.sync="localPagination.page"
        :total="localPagination.total"
        :page-size="localPagination.limit"
        @current-change="fetchNotifications" />
    </div>
    <dara-empty v-else icon="bell-slash" :description="$t('no-notifications-left')" />
  </div>
</template>

<script>
import { markAllNotificationsAsReaded, fetchNotifications } from '@/modules/notification/notification.service';

import DaraNotificationCard from '@/modules/notification/components/NotificationCard.vue';

export default {
  name: 'DaraNotificationListPage',
  components: {
    DaraNotificationCard,
  },
  props: {
    pagination: {
      type: Object,
      required: true,
    },
    showPagination: Boolean,
  },
  data() {
    return {
      skeleton: true,
      notifications: null,
      localPagination: this.pagination,
    };
  },
  computed: {
    hasNotifications() {
      return this.notifications?.length;
    },
  },
  mounted() {
    this.fetchNotifications();
  },
  methods: {
    fetchNotifications() {
      this.skeleton = true;
      this.notifications = null;

      fetchNotifications(this.localPagination)
        .then(data => {
          this.notifications = data.data;
          Object.assign(this.localPagination, data.pagination);
        })
        .catch(() => {
          this.notifications = null;
        })
        .finally(() => {
          this.skeleton = false;
        });
    },
    markAllNotificationsAsReaded() {
      markAllNotificationsAsReaded()
        .then(() => {
          this.$router.go(0);
        });
    },
  },
};
</script>
